export const formatFinderId = (id) => {
    if (id === null || id === undefined || id === '') {
        return 'N/A';
    }
    try {
        return `FND-${id.toString().padStart(5, '0')}`;
    } catch (error) {
        console.error("Error formatting Finder ID:", error);
        return 'N/A';
    }
};

export function pluralize(word, count) {
    return count === 1 ? word : word + 's';
} 